import posthog from 'posthog-js';

export const ANALYTICS_CONSENT_KEY = 'lbys_analytics_consent';

export const getAnalyticsConsent = () => {
    try {
        return window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    } catch (error) {
        return null;
    }
};

export const setAnalyticsConsent = (value) => {
    try {
        window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    } catch (error) {
        // The in-memory consent state still controls this browser session.
    }
};

export const captureAnalytics = (eventName, properties = {}) => {
    if (getAnalyticsConsent() !== 'granted') return;

    posthog.capture(eventName, properties);
};

export const withdrawAnalyticsConsent = () => {
    try {
        posthog.opt_out_capturing();
        posthog.reset();
    } catch (error) {
        // PostHog may not be initialized when a previously declined user returns.
    }
};
